import PropTypes from 'prop-types';
import { Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import { crearOEditarEntidadPension } from "../../services/entidades-pension-service";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormEntidadesPension = ({ modalState, onSaved }) => {
    const { entidadPension } = modalState.data;

    const defaultValues = {
        id: entidadPension.id || "",
        nit: entidadPension.nit || "",
        email: entidadPension.email || "",
        nombre: entidadPension.nombre || "",
        telefono: entidadPension.telefono || "",
        direccion: entidadPension.direccion || "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [entidadPension]);

    const onCreateEntidesPension = async (entidadPension) => {
        const resp = await crearOEditarEntidadPension({
            ...entidadPension,
        });
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSaved();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formEntidadPension"
            onSubmit={onCreateEntidesPension}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        rules={REQUIRED_RULE}
                        placeholder="Nombre entidad pensión"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        label="Nit"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nit"
                        rules={REQUIRED_RULE}
                        placeholder="Nit"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        label="Direccion"
                        errors={form.formState.errors}
                        control={form.control}
                        name="direccion"
                        rules={REQUIRED_RULE}
                        placeholder="Direccion"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        label="Telefono"
                        errors={form.formState.errors}
                        control={form.control}
                        name="telefono"
                        rules={REQUIRED_RULE}
                        placeholder="Telefono"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        label="Email"
                        errors={form.formState.errors}
                        control={form.control}
                        name="email"
                        rules={REQUIRED_RULE}
                        placeholder="Email"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormEntidadesPension.propTypes = {
    modalState: PropTypes.object,
    onSaved: PropTypes.func
}

export default FormEntidadesPension;
